import React, { useContext, useMemo } from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { aggregateData } from '../functions';
import GraphTable from '../mechanisms/graphtable';
import { formatCurrency } from '../functions';
import { currencyPrefix } from '../single-card';
import { DashboardContext } from '../mechanisms/card';
import DashView from '../mechanisms/dashview';

const JourneyOpportunitiesDashboard = ({ data = [], status, name = 'journeyopportunities' }) => {

    const { type } = useContext(DashboardContext)

    const graph = useMemo(() => {
        const filteredData = status ? data.filter(d => d.status === status) : data
        return aggregateData('value', filteredData, 'journey_name')
    }, [data, status])

    return (
        <>
            {type === 'table' ? <GraphTable rows={graph} columns={[
                { field: 'journey_name', headerName: 'Jornada', flex: 1, },
                { field: 'count', headerName: 'Quantidade', flex: 1, },
                {
                    field: 'value', headerName: 'Valor', flex: 1,
                    renderCell: ({ value, row }) => `${currencyPrefix[row?.currency]} ${formatCurrency(value*100, row?.currency)}`
                }
            ]} />
                : <DashView name={name} rows={graph} vx={'journey_name'} vy={['value', 'count']} renderValue={(vy, row) => {
                    if (vy === 'value')
                        return `${currencyPrefix[row?.currency]} ${formatCurrency(row[vy]*100, row?.currency)}`
                    return row[vy]
                }} />
            }
        </>
    );
}


export default JourneyOpportunitiesDashboard
